import * as React from 'react';
import { User } from '../types/User';

interface Props {
  logout: () => void;
  user: User | null;
  children?: any;
}

const Footer: React.SFC<Props> = (_props: Props) => {
  const logo: string =
    require('../images/Ferritico_wordmark_final.svg').default;
  return (
    <footer className="app-footer">
      <div className="app-container app-footer__row">
        <div>
          <a href="/">
            <img src={logo} alt="Ferritico" width="140" />
          </a>
        </div>
        <div className="app-footer__contact">
          <a href="mailto:contact@ferritico.com">contact@ferritico.com</a>
          <div>
            <a href="https://ferritico.com/" target="_blank" rel="noopener noreferrer">
              Ferritico Website
            </a>
          </div>
        </div>
        <div>
          <span>Phone: +46 (0)8 121 530 03</span>
        </div>
        <div>
          <span>
            © {new Date().getFullYear()} Ferritico. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
